import styled from "styled-components";
import { Modal } from "components/Modal";

export const TransactionConfirmationModalContainer = styled(Modal)`
  .modal-dialog {
    max-width: 560px;

    .modal-content {
      padding: 0;
      border-radius: 16px;

      .modal-body {
        padding: 0;
        margin-top: 0;

        .modal-header {
          padding: 20px 24px;
          border-bottom: 1px solid ${({ theme }) => theme.input.border.color};

          .modal-title {
            margin: 0;
            font-size: 18px;
            font-weight: 500;
            color: ${({ theme }) => theme.card.font.tertiary};
            font-family: "Geist", sans-serif;
          }
        }

        .modal-body-content {
          padding: 24px;

          .info-banner {
            display: flex;
            gap: 12px;
            padding: 12px 16px;
            background: #eff6ff;
            border: 1px solid #bfdbfe;
            border-radius: 8px;
            margin-bottom: 24px;

            .info-icon {
              flex-shrink: 0;
              width: 20px;
              height: 20px;
              color: #3b82f6;
              display: flex;
              align-items: center;
              justify-content: center;

              svg {
                width: 20px;
                height: 20px;
              }
            }

            .info-text {
              font-size: 14px;
              font-weight: 400;
              color: #1e40af;
              line-height: 1.5;
              margin: 0;
              font-family: "Geist", sans-serif;
            }
          }

          .bank-details-section {
            background: #f9fafb;
            border-radius: 8px;
            padding: 16px;
            margin-bottom: 24px;

            .section-title {
              font-size: 14px;
              font-weight: 500;
              color: #6b7280;
              margin: 0 0 16px 0;
              font-family: "Geist", sans-serif;
            }

            .bank-detail-row {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 12px;

              &:last-child {
                margin-bottom: 0;
              }

              .detail-label {
                font-size: 14px;
                font-weight: 400;
                color: #6b7280;
                font-family: "Geist", sans-serif;
              }

              .detail-value {
                font-size: 14px;
                font-weight: 500;
                color: ${({ theme }) => theme.card.font.tertiary};
                text-align: right;
                font-family: "Geist", sans-serif;
              }
            }
          }

          .amount-section {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 16px 0;
            margin-bottom: 24px;

            .amount-label {
              font-size: 16px;
              font-weight: 500;
              color: ${({ theme }) => theme.card.font.tertiary};
              margin: 0;
              font-family: "Geist", sans-serif;
            }

            .amount-value {
              font-size: 16px;
              font-weight: 600;
              color: ${({ theme }) => theme.card.font.tertiary};
              margin: 0;
              font-family: "Geist", sans-serif;
            }
          }

          .action-buttons {
            display: flex;
            justify-content: space-between;
            gap: 12px;
          }

          .verification-section {
            .verification-prompt {
              font-size: 14px;
              font-weight: 400;
              color: #6b7280;
              line-height: 1.5;
              margin: 0 0 20px 0;
              font-family: "Geist", sans-serif;
            }

            .resend-link {
              display: inline-block;
              background: none;
              border: none;
              padding: 0;
              margin: 12px 0 24px 0;
              font-size: 14px;
              font-weight: 500;
              color: #3b82f6;
              cursor: pointer;
              font-family: "Geist", sans-serif;

              &:disabled {
                color: #9ca3af;
                cursor: not-allowed;
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .modal-dialog {
      max-width: 100%;
      margin: 0 16px;

      .modal-content {
        .modal-body {
          .modal-header {
            padding: 16px 20px;

            .modal-title {
              font-size: 16px;
            }
          }

          .modal-body-content {
            padding: 20px;

            .action-buttons {
              flex-direction: column-reverse;
            }
          }
        }
      }
    }
  }
`;
